import { render, staticRenderFns } from "./agent-protocol.vue?vue&type=template&id=bd8ac92c&scoped=true"
import script from "./agent-protocol.vue?vue&type=script&lang=js"
export * from "./agent-protocol.vue?vue&type=script&lang=js"
import style0 from "./agent-protocol.vue?vue&type=style&index=0&id=bd8ac92c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8ac92c",
  null
  
)

export default component.exports